import { Component, inject } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { cibAdguard } from '@coreui/icons';
/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-mfa-settings-modal',
  templateUrl: './mfa-settings-modal.component.html',
  styleUrl: './mfa-settings-modal.component.scss',
  standalone: false,
})
export class MfaSettingsModalComponent {
  protected authService = inject(AuthService);

  public visible = true;

  icons = {
    cibAdguard,
  };

  toggleVisibility(visible: boolean) {
    this.visible = visible;
  }

  backdropClick(visible: boolean) {
    this.visible = visible;
  }
}

// TODO: STILL IN PROGRESS, NEED to finish
